import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import {
  qConfigurationKey,
  QConfigurationKey,
} from "../../odata/appu4dm/QAppU4DM";
import { ConfigurationKey as ConfigurationKeyResponse } from "../../odata/appu4dm/AppU4DMModel";
import { odataFetch } from "../../lib/odata-fetch";
import { useQuery } from "@tanstack/react-query";
import { configurationKeys } from "./configuration-keys";

type ConfigurationKey =
  | "ResultStrategyManagement"
  | "nonConformanceLifeCycleforMaterialItem";

export function useConfiguration(config: ConfigurationKey) {
  const { data, ...query } = useQuery({
    queryKey: configurationKeys.get(config),
    queryFn: ({ meta }) => fetchConfiguration(config, meta!.token!),
    enabled: ({ meta }) => !!meta?.token,
  });

  return {
    config: data?.value[0],
    ...query,
  };
}

export function fetchConfiguration(config: ConfigurationKey, token: string) {
  const builder = createQueryBuilderV4(
    "ConfigurationKey",

    new QConfigurationKey()
  ).filter(qConfigurationKey.NId.eq(config));

  return odataFetch<ConfigurationKeyResponse>({ builder, token });
}
